import { Minus, Plus } from '@aktiia/design-system';
import cx from 'classnames';
import { max, min } from 'mathjs';

import { ButtonIcon } from '../../../button-icon';
import { INumberInputProps } from './types';

export const NumberInput = ({ value, onChange, placeholder, className, minValue, maxValue }: INumberInputProps) => {
  const decreaseValue = () => onChange(max(value - 1, minValue !== undefined ? minValue : Number.NEGATIVE_INFINITY));
  const increaseValue = () => onChange(min(value + 1, maxValue !== undefined ? maxValue : Number.POSITIVE_INFINITY));

  return (
    <div className="flex flex-1 relative items-center">
      <ButtonIcon icon={<Minus className="scale-75" />} onClick={decreaseValue} />
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(+event.target.value)}
        placeholder={placeholder ?? undefined}
        className={cx(className, 'h-[48px] max-w-[176px] mx-2')}
      />
      <ButtonIcon icon={<Plus className="scale-75" />} onClick={increaseValue} />
    </div>
  );
};
